



import Vue from "vue";
import data from "@/datatables/accounts/cashflow/index";
import datatable from "@/utils/datatable/components/datatable.vue";
export default Vue.extend({
  name: "cashflow",
  components:{
    datatable
  },
  data(){
    return {
        data
    }
  },
});
